import React from 'react';

import ManagamentPlan from 'assets/livenicons/managament_plan.png';

import styles from './styles.module.scss';

export const Goals = () => {
  return (
    <div className={styles.container}>
      <h3>
        People just like you achieved great results using our
        <br />
        <span className={styles.accent}>Well-being Management Plan!</span>
      </h3>
      <img src={ManagamentPlan} alt="" />
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <p className={styles.number}>83%</p>
          <p className={styles.description}>
            of users were able to{' '}
            <span className={styles.accent}>improve their well-bein</span> after
            just 6 weeks
          </p>
        </div>
        <div className={styles.content}>
          <p className={styles.number}>77%</p>
          <p className={styles.description}>
            of users started with{' '}
            <span className={styles.accent}>
              similar levels of energy levels
            </span>{' '}
            as you
          </p>
        </div>
        <div className={styles.content}>
          <p className={styles.number}>45%</p>
          <p className={styles.description}>
            of users suffer from{' '}
            <span className={styles.accent}>the same issues as you</span>
          </p>
        </div>
      </div>
    </div>
  );
};
